
const Paras = 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.';

export const articalsData = [
    {
        id: 1,
        title: 'Articles',
        para: Paras,
        icon: "file-text",
        class: "col-xl-4 xl-100 box-col-6"
    },
    {
        id: 2,
        title: 'Knowledgebase',
        para: Paras,
        icon: "book-open",
        class: "col-xl-4 xl-50 col-sm-6 box-col-6"
    },
    {
        id: 3,
        title: 'Support',
        para: Paras,
        icon: "aperture",
        class: "col-xl-4 xl-50 col-sm-6 box-col-12"
    }
]

export const questionFaqData=[
    {
        "btnname":"Integrating WordPress with Your Website?",
        "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
    },
    {
        "btnname":"WordPress Site Maintenance ?",
        "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
    },
    {
        "btnname":"Meta Tags in WordPress ?",
        "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
    },
    {
        "btnname":"WordPress in Your Language ?",
        "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
    }
]

export const intellectualData=[
    {
        "title":"Intellectual Property",
        "subdata":[
            {
                "btnname":"WordPress Site Maintenance ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"WordPress in Your Language ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"Integrating WordPress with Your Website ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            }
        ]
    },
    {
        "title":"Selling And Buying",
        "subdata":[
            {
                "btnname":"WordPress Site Maintenance ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"Meta Tags in WordPress ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"Validating a Website ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"Know Your Sources ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            }
        ]
    },
    {
        "title":"User Accounts",
        "subdata":[
            {
                "btnname":"Integrating WordPress with Your Website ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"WordPress Site Maintenance ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"WordPress in Your Language ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"Validating a Website ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            },
            {
                "btnname":"Meta Tags in WordPress ?",
                "discription":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus  mus."
            }
        ]
    }                  
]

export const latestData =[
    {
        "icon":"rotate-cw",
        "time":"10 minutes ago",
        "paragraph":"David Linner requested money back for a double debit card charge"
    },
    {
        "icon":"dollar-sign",
        "time":"2 hours ago",
        "paragraph":"All sellers have received monthly payouts"
    },
    {
        "icon":"link",
        "time":"45 minutes ago",
        "paragraph":"User Christopher Wallace is on hold and awaiting for staff reply"
    },
    {
        "icon":"check",
        "time":"Dec 7, 11:48",
        "paragraph":"Ticket #43683 has been closed by Victoria Wilson"
    }
]

export const navigationData=[
    {
        "icon":"edit",
        "name":"Tutorials"
    },
    {
        "icon":"globe",
        "name":"Help center"
    },
    {
        "icon":"book-open",
        "name":"Knowledgebase"
    },
    {
        "icon":"file-text",
        "name":"Articles",
        "badge":"42"
    },
    {
        "icon":"youtube",
        "name":"Video Tutorials",
        "badge":"648"
    },
    {
        "icon":"message-circle",
        "name":"Ask our community"
    },
    {
        "icon":"mail",
        "name":"Contact us"
    }
]

export const learningData = [
    {
      Id: 1,
      img: "faq/3.jpg",
      date: "15 April 2022",
      writer: "Admin",
      hits: "0",
      short_description: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.Perspiciatis unde omnis iste natus error sit.Dummy text",
      title: "Web Design",
      star:"5"
    },
    {
      Id: 2,
      img: "faq/2.jpg",
      date: "15 April 2022",
      writer: "Admin",
      hits: "0",
      short_description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
  
      title: "UX Design",
      star:"4"
    },
    {
      Id: 3,
      img: "faq/2.jpg",
      date: "15 April 2022",
      writer: "Admin",
      hits: "0",
      short_description: "Cerspiciatis Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. unde omnis iste natus error sit.Dummy text",
      title: "Web Design",
      star:"5"
    },
    {
      Id: 4,
      img: "faq/1.jpg",
      date: "15 April 2022",
      writer: "Admin",
      hits: "0",
      short_description: "Perspiciatis Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. unde omnis  iste natus error sit.Dummy text",
      title: "Web Development",
      star:"4.5"
    },
    {
      Id: 5,
      img: "faq/3.jpg",
      date: "15 April 2022",
      writer: "Admin",
      hits: "0",
      short_description: "Herspiciatis Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. unde omnis  iste natus error sit.Dummy text",
      title: "UI Design",
    },
    {
      Id: 6,
      img: "faq/2.jpg",
      date: "15 April 2022",
      writer: "Admin",
      hits: "0",
      short_description: "Aerspiciatis Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. unde omnis iste natus error sit.Dummy text",
      title: "UX Design",
    },
    {
      Id: 7,
      img: "faq/3.jpg",
      date: "15 April 2022",
      writer: "Admin",
      hits: "0",
      short_description: "Herspiciatis Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. unde omnis  iste natus error sit.Dummy text",
      title: "UI Design",
    },
    {
      Id: 8,
      img: "faq/2.jpg",
      date: "15 April 2022",
      writer: "Admin",
      hits: "0",
      short_description: "Aerspiciatis Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. unde omnis iste natus error sit.Dummy text",
      title: "UX Design",
    },
]

export const latestArticalFaqData =[
    { 
        "classxl":"4",
        "classmd":"6",
        "alldata":[
            {
                "classsm":"12",
                "icon":"codepen",
                "title":"Using Video",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            },
            {
                "classsm":"12",
                "icon":"codepen",
                "title":"Vel illum qu",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            },
            {
                "classsm":"12",
                "icon":"codepen",
                "title":"Cum sociis natoqu",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            }
        ]  
    },
    { 
        "classxl":"4",
        "classmd":"6",
        "alldata":[
            {
                "classsm":"12",
                "icon":"file-text",
                "title":"Donec pede justo",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            },
            {
                "classsm":"12",
                "icon":"file-text",
                "title":"Nam quam nunc",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            },
            {
                "classsm":"12",
                "icon":"file-text",
                "title":"Using Video",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            }
        ]  
    },
    { 
        "classxl":"4",
        "alldata":[
            {
                "classxl":"12",
                "classmd":"6",
                "icon":"youtube",
                "title":"Vel illum qu",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            },
            {
                "classxl":"12",
                "classmd":"6",
                "icon":"youtube",
                "title":"Cum sociis natoqu",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            },
            {
                "classxl":"12",
                "icon":"youtube",
                "title":"Donec pede justo",
                "paragraph":"Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
            }
        ]  
    }
]